<template>
  <div class="slider">
    <div
      :class="['slider--item', { selected: index === landingIndex }]"
      v-for="(s, index) in sources"
      :key="index"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    sources: {
      type: Array,
      required: false,
    },
    landingIndex: {
      type: Number,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  height: fit-content;
  width: fit-content;
  display: flex;

  &--item {
    width: toRem(20);
    height: toRem(3);
    margin: 0 toRem(2);
    background-color: $ui-white;
    border-radius: toRem(200);
    transition: all 0.3s ease-in-out;

    &.selected {
      background-color: $primary-yellow;
    }
  }
}
</style>
